import { createAsyncStateHook } from './utils'
import { getPressReleases } from 'src/services/pressReleasesServices'

export const usePressReleases = createAsyncStateHook(
  'pressRelease',
  getPressReleases
)
